import { ArrowLeft, ArrowRight } from 'lucide-react';
import './ServiceDetail.css';
import ScrollToTop from '../../Components/Scrolltop/Scrolltop';

const ImplementationResearch = () => {

   <ScrollToTop />
  return (
    <>
      <section className="service-hero">
        <div className="container">
          <a href="/services" className="back-link">
            <ArrowLeft size={24} /> Back to All Services
          </a>
          <h1>Implementation Research & Adaptive Learning</h1>
          <p className="lead">
            We support partners to generate real-time evidence on what works, for whom, and under what conditions during implementation. Our approach strengthens adaptive management, continuous improvement, and learning cultures.
          </p>
        </div>
      </section>

      <section className="section service-detail">
        <div className="container">
          <h2>Our Key Services</h2>
          <ul className="service-list">
            <li>
              <strong>Embedded learning and adaptive management frameworks</strong>
              <p>Integrating real-time evidence directly into decision-making processes for flexible, responsive programming.</p>
            </li>
            <li>
              <strong>Process evaluations and fidelity assessments</strong>
              <p>Understanding how interventions are delivered in practice and whether they match the intended design.</p>
            </li>
            <li>
              <strong>Rapid-cycle learning and real-time feedback loops</strong>
              <p>Short, iterative testing cycles with immediate data insights to drive quick improvements.</p>
            </li>
            <li>
              <strong>Pilot testing, prototyping, and scale-readiness assessments</strong>
              <p>Systematic testing of innovations to validate effectiveness before full-scale rollout.</p>
            </li>
            <li>
              <strong>Learning agendas and implementation dashboards</strong>
              <p>Prioritized questions and visual, interactive tools to track progress and inform decisions.</p>
            </li>
          </ul>

          <div className="cta-section">
            <h3>Ready to Embrace Adaptive Management?</h3>
            <div className="btn-group">
              <a href="/contact" className="btn btn-primary">
                Start Your Adaptive Learning Project <ArrowRight size={24} />
              </a>
              <a href="/services" className="btn btn-secondary">
                Explore All Services <ArrowRight size={24} />
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        {/* Same footer as above - copy the footer block from Merl.js here */}
        <div className="footer-grid">
          {/* ... paste the full footer content ... */}
        </div>
        <div className="copyright">
          © 2025 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
        </div>
      </footer>
    </>
  );
};

export default ImplementationResearch;